import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundRoute() {
  return (
    <div className="grid min-h-screen place-items-center bg-[var(--color-paper)] px-6">
      <div className="max-w-md text-center">
        <p className="eyebrow">Error 404</p>
        <h1 className="font-display-tight mt-3 text-6xl font-semibold tracking-tight">
          Pagina no encontrada
        </h1>
        <p className="mt-4 text-[var(--color-ink-muted)]">
          La direccion que buscas no existe o fue movida.
        </p>
        <Button asChild className="mt-8">
          <Link to="/">Volver al inicio</Link>
        </Button>
      </div>
    </div>
  );
}
